import _ from 'lodash'
import { SET_PROGRESS } from '../data/progress/constants'
import { SET_UI } from '../data/versions/constants'
import { actions } from '../imports'
import { getProgressForServer, getVersions } from '../selectors'

// componentDidUpdate(prevProps) {
//     if (this.props.uiVersion != null && this.props.uiVersion !== prevProps.uiVersion) {
//         console.info(`Detected UI version ${this.props.uiVersion}`)
//     }
// }

const LoadingBarMiddleware = store => next => (action) => {
    switch (action.type) {
        case SET_PROGRESS: {
            const server = action.payload.serverName
            const prevState = getProgressForServer(store.getState(), server)
            const result = next(action)
            const newState = getProgressForServer(store.getState(), server)
            // If the state has changed, then log the new state
            if (!_.isEqual(prevState, newState)) {
                const message = `updateProgress request for ${server} ${
                    newState.value === 1 ? 'completed' : ''
                }`
                store.dispatch(actions.log(message))
            }
            return result
        }

        // todo: this does not belong here and should be moved to the sync feature...!
        case SET_UI: {
            const prevUiVersion = getVersions(store.getState()).uiVersion
            const result = next(action)
            const newUiVersion = getVersions(store.getState()).uiVersion
            if (newUiVersion != null && prevUiVersion !== newUiVersion) {
                store.dispatch(actions.log(`Detected UI version ${newUiVersion}`))
            }
            return result
        }

        default:
            return next(action)
    }
}

export default LoadingBarMiddleware



// WEBPACK FOOTER //
// ./src/features/LoadingBar/middleware/index.js